import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { UserRolesEntity } from '../../domain/entities/UserRolesEntity'

export class UserRolesModel extends UserRolesEntity {
  constructor(dataDto: UserRolesModel) {
    super()
    mapEntityProperties<UserRolesEntity>(this, dataDto)
  }
}
